import { StatusName } from '@chatsdet/ui';
export type QaRunStatus =
  | 'pending'
  | 'running'
  | 'completed'
  | 'failed'
  | 'canceled'
  | 'completed_with_errors'
  | 'timeout';

export type QaRunListItem = {
  id: string;
  orgId: string;
  propertyId: string;
  propertyName: string;
  type: 'qa';
  status: QaRunStatus;
  startedAt: string | null;
  finishedAt: string | null;
  createdAt: string;
  pagesTested: number;
  casesTested: number;
  healthyTests: number;
  unhealthyTests: number;
};

export type QaRunsResponse = {
  ok: boolean;
  runs: QaRunListItem[];
  pagination: {
    page: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
  };
};

export type StartQaRunResponse = {
  ok: boolean;
  qaRunId: string;
  mode: 'direct';
  pageTestCount: number;
};

export type QaRunDetailResponse = {
  ok: boolean;
  run: QaRunListItem;
};

export type AttachPageToLatestRunResponse = {
  ok: boolean;
  qaRunId: string;
  qaReportId: string;
  jobId: string;
  brokerJobId: string | null;
  replacedReportId: string | null;
  createdNewRun?: boolean;
  attachedToLatestRun?: boolean;
  error?: string;
};

export type ContinueQaReportResponse = {
  ok: boolean;
  qaReportId: string;
  jobId: string;
  brokerJobId: string | null;
  error?: string;
};

export type QaReportStatus = 'pending' | 'running' | 'issues_found' | 'no_issues' | 'failed';

export type QaReportListItem = {
  id: string;
  canonicalPageId: string;
  pageUrl: string;
  pageTitle: string | null;
  status: QaReportStatus;
  healthyCount: number;
  unhealthyCount: number;
  totalCount: number;
  hasIssues: boolean;
  createdAt: string;
  completedAt: string | null;
};

export type QaRunReportsResponse = {
  ok: boolean;
  reports: QaReportListItem[];
  pagination: {
    page: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
  };
};

export type QaRunReportTimelineBucket = {
  bucketStart: string;
  passed: number;
  failed: number;
  notApplicable: number;
};

export type QaRunReportTimelineResponse = {
  ok: boolean;
  bucketMinutes: number;
  buckets: QaRunReportTimelineBucket[];
};

export function getQaRunStatusMeta(status: QaRunStatus): {
  label: string;
  color: 'green' | 'blue' | 'yellow' | 'red' | 'gray';
  statusName: StatusName;
} {
  switch (status) {
    case 'pending':
      return { label: 'Pending', color: 'gray', statusName: 'queued' };
    case 'running':
      return { label: 'Running', color: 'blue', statusName: 'running' };
    case 'completed':
      return { label: 'Completed', color: 'green', statusName: 'success' };
    case 'failed':
      return { label: 'Failed', color: 'red', statusName: 'failed' };
    case 'canceled':
      return { label: 'Canceled', color: 'yellow', statusName: 'canceled' };
    case 'completed_with_errors':
      return { label: 'Partial', color: 'yellow', statusName: 'warning' };
    case 'timeout':
      return { label: 'Timed Out', color: 'yellow', statusName: 'timeout' };
    default:
      return { label: 'Unknown', color: 'gray', statusName: 'queued' };
  }
}
